export const formatDuration = (ms?: number | null): string => {
    if (ms == null) {
        return "N/A"
    }

    if (ms < 1000) {
        return `${Math.round(ms)} ms`
    }

    const seconds = ms / 1000

    if (seconds < 60) {
        const precision = seconds < 10 ? 2 : 1
        return `${seconds.toFixed(precision)} s`
    }

    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    if (remainingSeconds < 1) {
        return `${minutes} min`
    }

    return `${minutes} min ${remainingSeconds.toFixed(1)} s`
}
